import { useLanguage } from "@/context/LanguageContext";

export default function LanguageSwitcher() {
  const { lang, setLang, t } = useLanguage();
  const options = [
    { code: "en", label: "EN" },
    { code: "hi", label: "हिंदी" },
  ];
  return (
    <div
      className="flex items-center border hairline"
      role="group"
      aria-label="Language / भाषा"
    >
      {options.map((o) => (
        <button
          key={o.code}
          type="button"
          data-testid={
            o.code === "hi" ? "language-switcher-hindi" : "language-switcher-button"
          }
          onClick={() => setLang(o.code)}
          className={`px-3 py-1.5 text-[12px] font-medium tracking-wider transition-all duration-300 ${
            lang === o.code
              ? "bg-gold text-obsidian"
              : "text-cream/70 hover:text-gold"
          } ${o.code === "hi" ? "font-sans" : ""}`}
        >
          {o.label}
          {o.code === "en" && lang === "en" ? (
            <span className="sr-only"> — {t.nav.home}</span>
          ) : null}
        </button>
      ))}
    </div>
  );
}
